/* mm-upsell-nachtragen.js — der Mehrfach-Upsell legt jetzt wirklich alles in den Korb.
 *
 * 29.08.2026, Mert zum 2er-SET-Upsell: „das muss funktionieren, das funktioniert nicht."
 *
 * GEMESSEN auf der Live-Produktseite:
 *   Haken bei „2er SET" gesetzt, Knopf zeigte korrekt „Jetzt sichern (1)".
 *   Nach dem Klick lag im Warenkorb **nur das Hauptprodukt**
 *   („Magic Milk FOR X5 - Standard x1"), der Upsell fehlte.
 *   Es ging genau EIN Aufruf an `/cart/add.js` raus - die App schickt den
 *   angehakten Artikel also gar nicht erst mit. Keine Fehlermeldung, nichts.
 *   Gegengeprueft: `mm-warenkorb-upcart.js` faengt weder Knopf noch Haken ab.
 *   Der Fehler liegt in der Upsell-App selbst.
 *
 * WAS DIESE DATEI TUT
 *   Sie schaut nach dem Klick nach, was tatsaechlich im Warenkorb gelandet ist,
 *   und traegt fehlende angehakte Artikel nach. Die App wird nicht angefasst.
 *
 * WARUM NACHSEHEN STATT EINFACH HINZUFUEGEN
 *   Sollte die App den Fehler eines Tages beheben, wuerde blindes Hinzufuegen
 *   jeden Artikel doppelt in den Korb legen. Deshalb wird erst der Warenkorb
 *   gelesen und nur ergaenzt, was fehlt. Repariert sich die App, tut diese
 *   Datei von selbst nichts mehr.
 */
(function () {
  'use strict';

  var WARTEN_MS = 1800;   /* der App ihren eigenen Versuch lassen */
  var laeuft = false;

  /* 02.09.2026 GEMESSEN: Die Upsell-Schalter heissen inzwischen
     `addon-toggle-input` und liegen teils in einem offenen Shadow-DOM. Die alte
     Suche nach `.st_single-upsell-checkbox-input` fand deshalb nichts mehr. */
  function alleKaesten() {
    var raus = [];
    (function suche(n) {
      if (n.tagName === 'INPUT' && n.type === 'checkbox' &&
          (n.className || '').toString().indexOf('addon-toggle-input') > -1) raus.push(n);
      if (n.className && String(n.className).indexOf('st_single-upsell-checkbox-input') > -1) raus.push(n);
      if (n.shadowRoot) [].forEach.call(n.shadowRoot.children, suche);
      [].forEach.call(n.children, suche);
    })(document.body);
    return raus;
  }

  function variantenNr(k) {
    var v = k.getAttribute('data-variant-id') || '';
    var m = v.match(/(\d+)\s*$/);
    return m ? m[1] : null;
  }

  function angehakte() {
    return alleKaesten()
      .filter(function (k) { return k.checked; })
      .map(variantenNr)
      .filter(Boolean);
  }

  function nachtragen(ids) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (korb) {
        var drin = {};
        (korb.items || []).forEach(function (i) { drin[String(i.variant_id)] = true; });
        var fehlt = ids.filter(function (id) { return !drin[id]; });
        if (!fehlt.length) { laeuft = false; return; }   /* App war doch schnell genug */

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: fehlt.map(function (id) { return { id: Number(id), quantity: 1 }; })
          })
        }).then(function (r) { return r.json(); }).then(function () {
          /* Der Warenkorb zeigt sonst weiter den alten Stand. */
          if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          laeuft = false;
        });
      })
      .catch(function () { laeuft = false; });
  }

  /* ------------------------------------------------------------------
     29.08.2026, Mert: „dann 2 er set section muss funktionieren".

     GEMESSEN auf der Live-Produktseite:
       Der Weg an sich funktioniert - Haken bei „2er SET", „Jetzt sichern (1)",
       danach lagen BEIDE Artikel im Korb (Hauptprodukt + 2er SET).
     ABER: Sobald sich am Warenkorb etwas aendert, setzt die App alle Haken
       zurueck - der Knopf zeigt aber weiter „(1)". Gemessen: 0 Haken gesetzt,
       Knopfbeschriftung unveraendert „Jetzt sichern (1)". Wer in diesem Zustand
       kauft, bekommt nur das Hauptprodukt, obwohl der Knopf etwas anderes
       verspricht. Genau das sieht von aussen aus wie „geht nicht".

     ZWEI GEGENMASSNAHMEN
       1. Haken, die der Kunde selbst gesetzt hat, werden nach einem stillen
          Zuruecksetzen wiederhergestellt. Nur diese - was der Kunde bewusst
          abwaehlt, bleibt abgewaehlt.
       2. Die Zahl am Knopf wird an die tatsaechlich gesetzten Haken angeglichen,
          damit Knopf und Auswahl nie auseinanderlaufen.
     ------------------------------------------------------------------ */
  var gewollt = {};        /* variantenNr -> true, vom Kunden gesetzt */

  document.addEventListener('change', function (e) {
    var b = e.target;
    if (!b || !b.classList) return;
    if (!b.classList.contains('st_single-upsell-checkbox-input') &&
        !b.classList.contains('addon-toggle-input')) return;
    var id = variantenNr(b);
    if (!id) return;
    if (b.checked) gewollt[id] = true; else delete gewollt[id];
  }, true);

  function knopfAngleichen() {
    var n = angehakte().length;
    var knoepfe = document.querySelectorAll('button');
    for (var i = 0; i < knoepfe.length; i++) {
      var b = knoepfe[i];
      var t = (b.textContent || '').replace(/\s+/g, ' ');
      if (!/jetzt sichern|in den warenkorb|abo starten/i.test(t)) continue;
      if (!/\(\s*\d+\s*\)/.test(t)) continue;       /* nur den Mehrfach-Knopf */
      var soll = 'In den Warenkorb (' + n + ')';
      if (n === 0) soll = 'In den Warenkorb';
      if (t.trim() !== soll) b.textContent = soll;
    }
  }

  function haken() {
    var kaesten = alleKaesten();
    if (!kaesten.length) return;
    for (var i = 0; i < kaesten.length; i++) {
      var b = kaesten[i];
      var id = variantenNr(b);
      /* Nur zuruecksetzen, was der Kunde gesetzt hatte und die App verloren hat. */
      if (id && gewollt[id] && !b.checked) {
        b.checked = true;
        b.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    knopfAngleichen();
  }

  /* Sparsam nachsehen: nur wenn sich im Upsell-Bereich wirklich etwas aendert. */
  if (window.MutationObserver) {
    var wartet = false;
    new MutationObserver(function () {
      if (wartet) return;
      wartet = true;
      window.setTimeout(function () { wartet = false; haken(); }, 400);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('change', function () {
    window.setTimeout(knopfAngleichen, 60);
  }, true);

  /* In der BLASENPHASE - die App soll ihren Klick zuerst bekommen. */
  document.addEventListener('click', function (e) {
    if (laeuft) return;
    var b = e.target && e.target.closest ? e.target.closest('button') : null;
    if (!b) return;
    /* Nur der Knopf des Mehrfach-Upsells; er traegt die Anzahl in Klammern.
       Der normale Kaufknopf heisst schlicht „Jetzt sichern" und bleibt aussen vor. */
    /* 02.09.2026, GEFUNDENER FEHLER: Frueher stand hier eine Pruefung auf den
       Knopftext „Jetzt sichern (1)". Der Text heisst inzwischen „In den
       Warenkorb" - damit griff diese Datei gar nicht mehr, und der angehakte
       Artikel fiel still unter den Tisch. Der Knopf wird jetzt an seinem NAMEN
       erkannt, nicht an seiner Beschriftung. */
    if (b.getAttribute('name') !== 'add' &&
        !(b.className || '').toString().match(/add-to-cart/)) return;

    var ids = angehakte();
    if (!ids.length) return;

    laeuft = true;
    window.setTimeout(function () { nachtragen(ids); }, WARTEN_MS);
  }, false);
})();
